export default __webpack_public_path__ + "media/images/brunch-7e58cd28439a78ce59a14d0bf6daf2df.png";